import { render, staticRenderFns } from "./ActivityLog.vue?vue&type=template&id=ef83d588&scoped=true"
import script from "./ActivityLog.vue?vue&type=script&lang=js"
export * from "./ActivityLog.vue?vue&type=script&lang=js"
import style0 from "./ActivityLog.vue?vue&type=style&index=0&id=ef83d588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef83d588",
  null
  
)

export default component.exports